import {
	AxisRange,
	AxisSide,
	LinePathOptions,
	useCartesianSerieRange,
	XAxisSide,
} from "@soft-db/d3-chart";
import { computed, ComputedRef } from "vue";
import { ChartAxisRangeOptions } from "./chart-axes-options";

export const useChartAxisRange = (
	range: ComputedRef<ChartAxisRangeOptions> | null,
	series: ComputedRef<LinePathOptions[]>,
	side: AxisSide
) => {
	const { xRange, yRange } = useCartesianSerieRange();

	const isXAxis = (side: AxisSide): side is XAxisSide => side === "bottom" || side === "top";

	const bounds = computed(() => {
		if (isXAxis(side)) {
			return xRange(series.value, side);
		} else {
			return yRange(series.value, side);
		}
	});
	return computed(() => {
		const newRange = range ? { ...range.value } : { max: null, min: null };
		if (newRange.min == null) newRange.min = bounds.value.min?.valueOf() || 0;
		if (newRange.max == null) newRange.max = bounds.value.max?.valueOf() || 0;

		return newRange as AxisRange;
	});
};
